/**
 * 作品案例列表
 * @author wangyichen
 * @since 18/07/16
 */
// import ACTIONS from 'constants/action.json5';
const initState = {
  list: [],
};

export default (state = initState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
